export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/d50cc34e778c6c20c755dccf4a153599.svg";